import { string, table } from "@rocicorp/zero";
import { coreFields } from "./shared";

export const resourceLink = table("resourceLinks")
	.from("resource_links")
	.columns({
		...coreFields,
		orgId: string().from("org_id"),
		link: string(),
		name: string().optional(),
		type: string().optional(),
	})
	.primaryKey("id");
